module.exports = __webpack_public_path__ + "4d415ce601fce7f70232df551073a8c2.xml";